<div class="main-container">
  <h2 class="main-container-header">Are you sure you want to delete {{ data.person.fullName }}?</h2>
  <div class="main-container-text">
    <p>
      Deleting this person will remove any and all records associated with their profile across your entire
      organization. This includes (but is not imited to):
    </p>
    <ul>
      <li>Deleting all values in custom and system fields that they have (person and tracked).</li>
      <li>Removing them from all team rosters.</li>
      <li>Removing them from all Workspaces.</li>
      <li>
        Removing any responses they have for Lineup Forms, Team Forms, and Team Surveys. Any evaluations that they
        submitted for other people will be preserved.
      </li>
      <li>No personal information or data will be preserved.</li>
    </ul>
    <p>
      <b>This action is permanent and cannot be undone.</b>
      If you are sure, please type "DELETE" in the field below.
    </p>
    <mat-form-field appearance="outline" class="value-description">
      <input data-testid="confirm-delete" matInput type="text" [(ngModel)]="textMatcherValue" />
    </mat-form-field>
    <p class="paragraph-margin">
      As an alternative, you can archive the person. An archived person will not appear in active searches and cannot be
      added to future teams, but we will preserve their data.
    </p>
  </div>
  <div class="button-container" mat-dialog-actions>
    <button
      mat-button
      class="delete-color"
      [mat-dialog-close]="deleteButtonClicked()"
      id="person-delete-modal-button"
      [disabled]="isDeleteButtonDisabled()"
    >
      Delete Person
    </button>
    <button
      mat-button
      class="archived-color"
      [mat-dialog-close]="archiveButtonClicked()"
      *ngIf="!data.person.isArchived()"
    >
      Archive Person
    </button>
    <button type="button" mat-button [mat-dialog-close]="cancelButtonClicked()">Cancel</button>
  </div>
</div>
